import { render, staticRenderFns } from "./DatosDeportivos.vue?vue&type=template&id=46c46ea4"
import script from "./DatosDeportivos.vue?vue&type=script&lang=js"
export * from "./DatosDeportivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports